import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiMail, FiMapPin, FiFacebook, FiInstagram } = FiIcons;

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer-grid">
        <div className="footer-brand">
          <a className="brand" href="#top">
            <img src="/windy-city-logo.svg" alt="Windy City Painters" />
            <span>WINDY CITY <b>PAINTERS</b></span>
          </a>
          <p>Premium painting with lasting impressions since 2008.</p>
          <div className="social-links">
            <a href="https://www.facebook.com/" aria-label="Facebook"><SafeIcon icon={FiFacebook} /></a>
            <a href="https://www.instagram.com/" aria-label="Instagram"><SafeIcon icon={FiInstagram} /></a>
          </div>
        </div>

        <div>
          <h3>Quick Links</h3>
          <nav aria-label="Footer navigation">
            <a href="#services">Services</a>
            <a href="#why-us">Why Us</a>
            <a href="#gallery">Gallery</a>
            <a href="#reviews">Reviews</a>
            <a href="#faq">FAQ</a>
          </nav>
        </div>

        <div>
          <h3>Contact</h3>
          <a href="tel:+15126792228"><SafeIcon icon={FiPhone} />512-679-2228</a>
          <a href="mailto:windycitypaintersinc@gmail.com"><SafeIcon icon={FiMail} />windycitypaintersinc@gmail.com</a>
          <p><SafeIcon icon={FiMapPin} />Austin, TX & surrounding areas</p>
        </div>
      </div>
      <div className="container footer-bottom">
        <span>© {year} Windy City Painters Inc. All rights reserved.</span>
        <span>Professional painting and resurfacing in Austin, Texas.</span>
      </div>
    </footer>
  );
}

export default Footer;